<template>
  <!--
    Renders a link-styled element that navigates on click WITHOUT a crawlable
    `href`. This keeps the footer (which appears on 30k+ pages) from passing
    internal link power to low-priority pages, while staying clickable and
    keyboard accessible for users. See issue #1027.
  -->
  <a
    role="link"
    tabindex="0"
    class="cursor-pointer"
    @click="onClick"
    @keydown.enter="onClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    // Internal route target, already resolved through localePath by the parent.
    to: {
      type: [String, Object],
      default: null,
    },
    // External URL.
    href: {
      type: String,
      default: null,
    },
    // Matches the <a target> semantics for external links.
    target: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClick(event) {
      // Let the parent attach custom behaviour (e.g. opening the tender wizard).
      this.$emit("click", event);

      if (this.href) {
        if (this.target === "_blank") {
          window.open(this.href, "_blank", "noopener");
        } else {
          window.location.href = this.href;
        }
        return;
      }

      if (this.to) {
        // Ignore redundant navigation to the current route.
        this.$router.push(this.to).catch(() => {});
      }
    },
  },
};
</script>
